import { type DefinePasswordInputType } from '@shelflix/schemas/authentication/definePassword';
import { create } from 'zustand';

interface DefinePasswordFormStore {
  formData: Partial<DefinePasswordInputType>;
  setFormData: (data: Partial<DefinePasswordInputType>) => void;
  resetForm: () => void;
}

export const useDefinePasswordFormStore = create<DefinePasswordFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
